import { render, staticRenderFns } from "./InputNumberCustom.vue?vue&type=template&id=63b50e1b&scoped=true&"
import script from "./InputNumberCustom.vue?vue&type=script&lang=js&"
export * from "./InputNumberCustom.vue?vue&type=script&lang=js&"
import style0 from "./InputNumberCustom.vue?vue&type=style&index=0&id=63b50e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b50e1b",
  null
  
)

export default component.exports